import { useQuery } from 'react-query';

// import { getVisitReportsList } from 'api/visitReports/getVisitReportsList';
import { getDigestReports } from 'api/digestReports/getDigestReports';

interface QueryOptions {
  slug: string;
  enabled?: boolean;
  isRefectNeeded?: boolean;
}

export const useGetDigestReportsList = ({ slug, enabled = true, isRefectNeeded = true }: QueryOptions) => {
  const { data, refetch, isLoading } = useQuery(['digestReportsListGet', slug], () => getDigestReports({ slug }), {
    refetchOnWindowFocus: false,
    refetchInterval: isRefectNeeded ? 5000 : false,
    enabled,
  });

  return { data, refetch, isLoading };
};

export default useGetDigestReportsList;
